import styled from 'styled-components'

const BoxAvatarImageStyled = styled.div`
  && {
    padding: 15px 0;
  }

`

export default BoxAvatarImageStyled